import type {
  PreferenceRecord,
  PreferenceService,
  PreferenceUpdate,
} from '@bingads-webui/common-types';

declare const require: <TModule>(moduleName: string) => TModule;

const { COPILOT_WIDTH } = require<{ COPILOT_WIDTH: number }>('@bingads-webui-react/copilot-utils');

export { COPILOT_WIDTH };

export interface ICopilotResizerPreference extends PreferenceRecord<string | number | null> {
  Data?: string | number | null;
  Name?: string;
}

type CopilotResizerSavedPreference = PreferenceUpdate<NonNullable<ICopilotResizerPreference['Data']>>;

export type ICopilotWidthPreferenceService = Required<Pick<
  PreferenceService<ICopilotResizerPreference, CopilotResizerSavedPreference>,
  'findByNameAtUserLevel'
>>;

export type ICopilotResizerPreferenceService = ICopilotWidthPreferenceService & Required<Pick<
  PreferenceService<ICopilotResizerPreference, CopilotResizerSavedPreference>,
  'setAtUserLevel'
>>;

export const COPILOT_MAX_WIDTH = 1000;

export const COPILOT_HEIGHT = '100%';

export const COPILOT_RESIZER_PREFERENCE_KEY = 'WebApp.CampaignUI.CopilotResizerWidth';

export const getCopilotWidthFromPreference = (isDynamicWidthEnabled?: boolean, preferenceService?: ICopilotWidthPreferenceService): number => {
  if (!isDynamicWidthEnabled || !preferenceService) {
    return COPILOT_WIDTH;
  }

  const copilotResizerWidthPreference = preferenceService.findByNameAtUserLevel(COPILOT_RESIZER_PREFERENCE_KEY);
  return parseInt(String(copilotResizerWidthPreference?.Data ?? COPILOT_WIDTH), 10);
};
